import { Link } from 'react-router-dom'
import { useCart } from '../hooks/useCart'

export function CartView() {
  const { cart, products, subtotal, removeItem } = useCart()

  const formatPrice = (n: number) => `$${n.toFixed(2)}`

  if (cart.length === 0) {
    return (
      <div className="page page--cart">
        <h1 className="page-title">🛒 Your Cart</h1>
        <div className="empty-state">
          <span className="empty-state-emoji" aria-hidden>🛒</span>
          <h2 className="empty-state-title">Your cart is empty!</h2>
          <p className="empty-state-p">Tap items on the home screen or scan to add groceries.</p>
          <Link to="/scan" className="btn-large btn-primary" style={{ textDecoration: 'none' }}>
            Scan items
          </Link>
          <Link to="/grocery" className="btn-large btn-secondary" style={{ textDecoration: 'none', marginTop: 12 }}>
            Home
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="page page--cart">
      <h1 className="page-title">🛒 Your Cart</h1>
      <ul className="cart-list" aria-label="Cart items">
        {cart.map((item, i) => {
          const product = products.get(item.productId)
          return (
            <li key={item.productId} className="cart-item animate-fade-in" style={{ animationDelay: `${i * 0.05}s` }}>
              <span className="cart-item-emoji" aria-hidden>{product?.imagePath ?? '📦'}</span>
              <span className="cart-item-name">{product?.name ?? 'Item'}</span>
              <span className="cart-item-qty">{item.quantity} × {formatPrice(product?.price ?? 0)}</span>
              <span className="cart-item-subtotal">{formatPrice(item.subtotal)}</span>
              <button
                type="button"
                className="cart-item-remove"
                onClick={() => removeItem(item.productId)}
                aria-label={`Remove ${product?.name ?? 'item'} from cart`}
              >
                ✕
              </button>
            </li>
          )
        })}
      </ul>
      <p className="cart-subtotal">Subtotal: {formatPrice(subtotal)}</p>
      <div className="cart-actions">
        <Link to="/scan" className="btn-large btn-secondary" style={{ textDecoration: 'none' }}>
          Scan More
        </Link>
        <Link to="/pay" className="btn-large btn-primary" style={{ textDecoration: 'none' }}>
          Pay Now
        </Link>
      </div>
    </div>
  )
}
